import { eventStreamService } from 'core-roblox-utilities';

const { eventTypes } = eventStreamService;

export enum PageContext {
  searchPage = 'searchPage'
}

export default {
  gameImpressions: (
    rootPlaceIds: number[],
    absPositions: number[],
    adsPositions: number[],
    suggestionKwd: string | undefined,
    suggestionReplacedKwd: string | undefined,
    suggestionCorrectedKwd: string | undefined,
    suggestionAlgorithm: string,
    algorithm: string,
    sessionInfo: string | undefined,
    ctx: PageContext,
    emphasisFlag: number
  ): [Record<string, string>, Record<string, undefined | string | number>] => [
    {
      name: 'gameImpressions',
      type: eventTypes.formInteraction,
      context: ctx
    },
    {
      rootPlaceIds: JSON.stringify(rootPlaceIds),
      absPositions: JSON.stringify(absPositions),
      adsPositions: JSON.stringify(adsPositions),
      suggestionKwd,
      suggestionReplacedKwd,
      suggestionCorrectedKwd,
      suggestionAlgorithm,
      algorithm,
      sessionInfo,
      ctx,
      emphasisFlag
    }
  ],
  gameDetailReferral: (
    pid: number,
    ad: number,
    pos: number,
    ctx: PageContext,
    tis: number,
    sessionInfo: string | undefined
  ): [Record<string, string>, Record<string, undefined | string>] => [
    {
      name: 'gameDetailReferral',
      type: eventTypes.formInteraction,
      context: ctx
    },
    {
      pid: pid.toString(),
      ad: ad.toString(),
      pos: pos.toString(),
      ctx,
      tis: tis.toString(),
      sessionInfo
    }
  ]
};
